// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"3d1533c6","551":"391d147f","828":"d619b0cc"}[chunkId] + ".chunk.js";
};